module.exports = __webpack_public_path__ + "img/main_page_banner_right.8a2fab75.png";